module.exports = __webpack_public_path__ + "img/ICRT_cancer_awarness_white_large.32c25f78.png";